import React from 'react';

import AsyncSelect from 'react-select/async';
import "./SearchField.scss";
import { useRemote } from '../../Utils/Utils';


const filterColors = (inputValue, colourOptions) => {
	return colourOptions.filter((i) =>
		i.label.toLowerCase().includes(inputValue.toLowerCase())
	);
};

const promiseOptions = (inputValue, colourOptions) =>
	new Promise((resolve) => {
		setTimeout(() => {
			resolve(filterColors(inputValue, colourOptions));
		}, 1000);
	});

export default ({queryFunc, toSelectOptions}) => {
	const remote = useRemote();

	toSelectOptions = (items) => {
		return items.map((item) => {
			return { value: item.assetRef, label: item.ticker + " - " + item.companyName, ticker: item.ticker, companyName: item.companyName };
		});
	}

	queryFunc = (inputValue) => {
		return remote
			.get(`/securities/search?q=${encodeURIComponent(inputValue)}`)
			.then((items) => toSelectOptions(items));
	}

	const formatOptionLabel = (option, { context }) => (
		<div style={{ display: 'flex', alignItems: 'center' }}>
		  <span style={{width:'55px'}}>{option.ticker}</span>
		  <span style={{ marginLeft: 8, color: '#888' }}>{option.companyName}</span>
		</div>
	  );

	return <AsyncSelect className="search-select-field search-field-width-l search-field-min-width" loadOptions={queryFunc} formatOptionLabel={formatOptionLabel} />
};